import { atom, atomWithDefault } from '~shared/lib/atom-state';

import { getParentNotificationHistory, getParentNotificationUnreadCount } from '../api';
import type { ApiParentNotificationHistoryResponse } from '../api';

export const parentNotificationHistoryAtom =
  atomWithDefault<ApiParentNotificationHistoryResponse | null>(() => null);

export const parentNotificationHistoryLoadingAtom = atomWithDefault<boolean>(() => false);

export interface ParentNotificationHistoryQuery {
  page?: number;
  limit?: number;
}

export const setParentNotificationHistoryAtom = atom<
  ApiParentNotificationHistoryResponse | null,
  ParentNotificationHistoryQuery,
  Promise<void>
>(
  (get) => get(parentNotificationHistoryAtom),
  async (get, set, params) => {
    const { page = 1, limit = 20 } = params ?? {};
    set(parentNotificationHistoryLoadingAtom, true);

    try {
      const data = await getParentNotificationHistory(page, limit);

      if (page === 1 || !data) {
        set(parentNotificationHistoryAtom, data);
      } else {
        const prev = get(parentNotificationHistoryAtom);

        set(parentNotificationHistoryAtom, {
          data: [...(prev?.data ?? []), ...data.data],
          pagination: data.pagination,
        });
      }
    } finally {
      set(parentNotificationHistoryLoadingAtom, false);
    }
  }
);

export const parentNotificationUnreadCountAtom = atomWithDefault<number>(() => 0);

export const refetchParentNotificationUnreadCountAtom = atom<number, undefined, Promise<void>>(
  (get) => get(parentNotificationUnreadCountAtom),
  async (_get, set) => {
    const count = await getParentNotificationUnreadCount();
    set(parentNotificationUnreadCountAtom, count);
  }
);
